import i18n, { projectLanguageToLng } from "./index";

export const READING_DOCUMENTS_STATUS = "Reading your documents";

const statusKeys = {
  "Analyzing user message": "status.analyzingMessage",
  [READING_DOCUMENTS_STATUS]: "status.readingDocuments",
  "Searching vault": "status.searchingVault",
  "Searching the web": "status.searchingWeb",
  "Updating case brief": "status.updatingBrief",
  "Crafting response": "status.craftingResponse"
} as const;

// The reading status carries how many files have landed: "Reading your documents (2/3)".
const READING_PROGRESS = /^(.*) \((\d+)\/(\d+)\)$/;

export const readingDocumentsStatus = (done: number, total: number) => `${READING_DOCUMENTS_STATUS} (${done}/${total})`;

export const isReadingDocumentsStatus = (status: string) =>
  status === READING_DOCUMENTS_STATUS || status.startsWith(`${READING_DOCUMENTS_STATUS} (`);

// `language` is the project's language; without it the interface language is used.
export function translateCaseBriefStatus(status: string, language?: string | null): string {
  const t = i18n.getFixedT(language === undefined ? null : projectLanguageToLng(language), "createProject");
  const progress = status.match(READING_PROGRESS);
  if (progress && progress[1] === READING_DOCUMENTS_STATUS) {
    return t("status.readingDocumentsProgress", { done: Number(progress[2]), total: Number(progress[3]) });
  }
  const key = statusKeys[status as keyof typeof statusKeys];
  return key ? t(key) : status;
}
